module.exports = __webpack_public_path__ + "static/media/providerSilverTop1D.c0f8a674.webp";